import styled, { keyframes } from 'styled-components';

const pulsar = keyframes`
    0% { box-shadow: 0 0 0 0 rgba(51, 94, 219, 0.6); }
    70% { box-shadow: 0 0 0 12px rgba(51, 94, 219, 0); }
    100% { box-shadow: 0 0 0 0 rgba(51, 94, 219, 0); }
`;

const subir = keyframes`
    from { opacity: 0; transform: translate(-50%, 10px); }
    to { opacity: 1; transform: translate(-50%, 0); }
`;

export const Moldura = styled.div<{ $escala: number }>`
    flex: none;
    width: ${p => 360 * p.$escala + 20}px;
    height: ${p => 800 * p.$escala + 20}px;
    padding: 10px;
    border-radius: ${p => 46 * p.$escala + 10}px;
    background: #111418;
    box-shadow: 0 18px 40px rgba(10, 25, 50, 0.35), inset 0 0 0 2px #2a2f36;
    position: relative;
`;

export const Tela = styled.div<{ $escala: number }>`
    width: ${p => 360 * p.$escala}px;
    height: ${p => 800 * p.$escala}px;
    border-radius: ${p => 46 * p.$escala}px;
    overflow: hidden;
    position: relative;
    background: #f4f6f8;
`;

export const App = styled.div<{ $escala: number }>`
    --primary: #1e4477;
    --tab-bg: rgba(30, 68, 119, 0.09);
    --texto: #11151c;
    --fundo: #f4f6f8;
    --card: #ffffff;
    --borda: #e8eaed;
    --verde-bg: #e7f5ec;
    --verde-fg: #1a7f43;
    --amarelo-bg: #fdf3cd;
    --amarelo-fg: #7a5c00;
    --vermelho-bg: #fdecea;
    --vermelho-fg: #b42318;

    width: 360px;
    height: 800px;
    transform: scale(${p => p.$escala});
    transform-origin: top left;
    position: relative;
    font-family: 'Roboto', 'Segoe UI', system-ui, -apple-system, sans-serif;
    color: var(--texto);
    background: var(--fundo);
    -webkit-font-smoothing: antialiased;
    user-select: none;

    * { box-sizing: border-box; margin: 0; padding: 0; }
    button { font-family: inherit; border: 0; cursor: pointer; }

    .tela { height: 800px; display: flex; flex-direction: column; position: relative; }

    .status {
        height: 34px; flex: none; display: flex; align-items: center; justify-content: space-between;
        padding: 0 22px 0 26px; font-size: 13px; font-weight: 500;
    }
    .status.clara { color: #fff; background: var(--primary); box-shadow: 0 2px 0 var(--primary); }

    .header-claro { flex: none; display: flex; align-items: center; justify-content: space-between; padding: 4px 16px 14px; }
    .header-claro h1 { color: var(--texto); font-size: 23px; font-weight: 700; letter-spacing: -.4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .header-claro .acoes { display: flex; align-items: center; gap: 14px; flex: none; }
    .btn-sair { display: flex; align-items: center; gap: 6px; border: 1px solid #d7dae0; border-radius: 9px; padding: 7px 12px; font-size: 15px; background: var(--card); }

    .header-cor { flex: none; background: var(--primary); color: #fff; padding: 6px 16px 18px; text-align: center; font-size: 19px; font-weight: 700; }

    .conteudo { flex: 1; overflow-y: auto; overflow-x: hidden; padding: 0 14px; scrollbar-width: none; }
    .conteudo::-webkit-scrollbar { display: none; }

    .cartao { background: var(--card); border: 1px solid var(--borda); border-radius: 13px; padding: 16px 16px 18px; margin-bottom: 16px; }
    .card-titulo { display: flex; align-items: center; gap: 11px; font-size: 19px; font-weight: 600; margin-bottom: 14px; }
    .card-titulo .obrigatorio { color: #d92d20; }
    .card-titulo .info { margin-left: auto; }
    .cartao.clicavel { cursor: pointer; }

    .veiculo { height: 183px; display: flex; align-items: center; justify-content: center; background: #fff; border-radius: 10px; overflow: hidden; }
    .veiculo img { max-width: 92%; max-height: 100%; object-fit: contain; }

    .grade { display: grid; grid-template-columns: 1fr 1fr; margin-top: 22px; text-align: center; }
    .grade > div { margin-bottom: 20px; }
    .grade > div:nth-last-child(-n+2) { margin-bottom: 0; }
    .grade .rotulo { font-size: 15px; color: #9aa1ab; margin-bottom: 5px; }
    .grade .valor { font-size: 17px; font-weight: 700; line-height: 1.28; word-break: break-word; }

    .rotulo-valor { font-size: 16px; color: #9aa1ab; margin-bottom: 4px; }
    .valor-grande { font-size: 25px; font-weight: 700; color: var(--primary); }
    .chip { display: inline-block; margin-top: 10px; background: var(--tab-bg); color: var(--primary); border-radius: 999px; padding: 7px 15px; font-size: 14px; font-weight: 700; letter-spacing: .3px; }

    .botao { display: flex; align-items: center; justify-content: center; gap: 9px; width: 100%; margin-top: 16px; background: var(--primary); color: #fff; border-radius: 9px; padding: 15px; font-size: 16px; font-weight: 700; }
    .botao.compacto { width: auto; margin: 18px auto 0; padding: 13px 30px; }

    .veu { position: absolute; inset: 0; background: rgba(0, 0, 0, .35); cursor: pointer; }
    .janela { position: absolute; left: 11px; right: 11px; top: 103px; bottom: 76px; background: #f7f5fa; border-radius: 15px; padding: 15px 15px 0; display: flex; flex-direction: column; overflow: hidden; }
    .modal-topo { display: flex; align-items: flex-start; gap: 8px; margin-bottom: 13px; flex: none; }
    .modal-topo h2 { color: var(--texto); font-size: 18px; font-weight: 500; }
    .modal-topo > div:first-child { min-width: 0; }
    .modal-topo .sub { font-size: 15px; color: #4b5563; margin-top: 3px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .modal-topo .acoes { margin-left: auto; display: flex; gap: 12px; align-items: center; padding-top: 2px; }
    .modal-topo .acoes button { background: none; display: flex; }
    .janela .lista { flex: 1; overflow-y: auto; scrollbar-width: none; padding-bottom: 12px; }
    .janela .lista::-webkit-scrollbar { display: none; }
    .janela .vazio { font-size: 15px; color: #6b7280; text-align: center; padding: 30px 10px; }

    .pagamento { background: var(--card); border-radius: 11px; padding: 12px 13px; margin-bottom: 9px; }
    .pagamento .linha { display: flex; align-items: center; }
    .pagamento .preco { font-size: 19px; font-weight: 700; }
    .pagamento .tipo { font-size: 15px; font-weight: 700; margin-top: 3px; }
    .pagamento .data { font-size: 14px; color: #9aa1ab; margin-top: 3px; }
    .pagamento .botao { margin-top: 10px; padding: 12px; font-size: 14px; }
    .selo { margin-left: auto; border-radius: 999px; padding: 6px 12px; font-size: 12px; font-weight: 700; letter-spacing: .3px; }
    .selo.pago { background: var(--verde-bg); color: var(--verde-fg); }
    .selo.aberto { background: var(--amarelo-bg); color: var(--amarelo-fg); }
    .selo.atraso { background: var(--vermelho-bg); color: var(--vermelho-fg); }

    .etapa { flex: none; padding: 16px 16px 0; display: flex; align-items: center; justify-content: space-between; }
    .etapa .texto { font-size: 17px; color: #6b7280; }
    .etapa .pct { font-size: 17px; font-weight: 700; color: var(--primary); }
    .barra { flex: none; height: 8px; margin: 10px 16px 0; background: #ece9f1; border-radius: 999px; overflow: hidden; }
    .barra i { display: block; height: 100%; background: var(--primary); border-radius: 999px; }
    .descricao { font-size: 17px; color: #6b7280; line-height: 1.35; margin-bottom: 16px; }
    .area-upload { width: 100%; border: 2px dashed #d5d8dd; border-radius: 11px; height: 178px; background: #fafafa; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px; }
    .area-upload span { font-size: 16px; font-weight: 500; color: var(--primary); }

    .intro { font-size: 17px; color: #6b7280; line-height: 1.35; padding: 16px 16px 14px; flex: none; }
    .visor { background: #4a4a4f; border-radius: 4px; height: 340px; display: flex; overflow: hidden; margin-bottom: 14px; position: relative; }
    .folha { background: #fff; width: 81%; margin: 0 auto; height: 100%; padding: 11px 13px; font-family: 'Times New Roman', Georgia, serif; color: #1f2937; }
    .folha h4 { text-align: center; font-size: 7px; margin-bottom: 6px; }
    .folha p { font-size: 4.6px; line-height: 1.5; margin-bottom: 4px; text-align: justify; }
    .controles { position: absolute; left: 0; right: 0; bottom: 0; height: 30px; background: #fff; display: flex; align-items: center; justify-content: center; gap: 9px; font-size: 9px; color: #374151; }
    .controles .pag { background: #e5e7eb; border-radius: 3px; padding: 2px 5px; }

    .abas { flex: none; height: 78px; padding-bottom: 22px; display: flex; background: var(--card); border-top: 1px solid #eceef1; }
    .aba { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px; font-size: 13px; color: #4b5563; background: none; }
    .aba.ativa { background: var(--tab-bg); color: var(--primary); font-weight: 500; }
    .barra-gestos { position: absolute; bottom: 7px; left: 50%; transform: translateX(-50%); width: 118px; height: 4px; border-radius: 999px; background: #8a9099; z-index: 5; }

    .destaque { animation: ${pulsar} 1.6s ease-out infinite; }

    .aviso-toque {
        position: absolute; left: 50%; bottom: 100px; transform: translateX(-50%);
        background: #1f2328; color: #fff; border-radius: 10px; padding: 11px 16px;
        font-size: 15px; font-weight: 500; white-space: nowrap; z-index: 10;
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
        animation: ${subir} 0.2s ease-out;
    }
`;
